import { ArrowRight } from "lucide-react";
import { scrollToReserva } from "./SmoothScroll";

// Único CTA de toda la landing. Estilo, tamaño, borde, color y animación idénticos.
// En el header (compact) el texto se acorta en móvil para que nunca se corte.
export default function CTAButton({ className = "", testid = "cta-reservar", compact = false }) {
  return (
    <button
      data-testid={testid}
      onClick={scrollToReserva}
      className={`group btn-ghost-gold rounded-none inline-flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap px-5 md:px-9 py-3 md:py-4 text-[10px] md:text-xs ${className}`}
    >
      {compact ? (
        <>
          <span className="sm:hidden">Reservar</span>
          <span className="hidden sm:inline">Reservar valoración</span>
        </>
      ) : (
        <span>Reservar valoración</span>
      )}
      <ArrowRight
        size={14}
        className="transition-transform duration-300 ease-out group-hover:translate-x-1.5"
      />
    </button>
  );
}
